module.exports = __webpack_public_path__ + "img/harsh-cornering_map.7d1ed76f.svg";